import { ReactElement } from 'react';
import { UsersListContainer } from '../../../modules/admin/containers/UsersList.container';

export const UsersView = (): ReactElement => <UsersListContainer />;
